export default "__VITE_ASSET__Digq1o2n__"